import React, { useEffect, useMemo, useState } from "react";
import ServiceGlyph from "./ServiceGlyph";
import ServiceSectionHead from "./ServiceSectionHead";
import mapServiceItem from "./mapServiceItem";

const groupIcons = {
    "Empresas del sector salud": "icon-clinic",
    "Empresas de otros rubros": "icon-office",
};

const cardIcons = {
    "Actualización clínica por especialidad": "icon-stethoscope",
    "RCP y Soporte Vital Básico (BLS)": "icon-heartbeat",
    "Soporte Vital Avanzado (ACLS)": "icon-siren",
    "Bioseguridad y control de infecciones": "icon-prevention",
    "Farmacovigilancia y uso racional de medicamentos": "icon-pharma",
    "Historia clínica electrónica y HL7/FHIR": "icon-article",
    "Inteligencia artificial aplicada a la práctica clínica": "icon-chip",
    "Genómica y medicina de precisión": "icon-dna",
    "Telemedicina y consulta virtual": "icon-laptop",
    "Responsabilidad médico-legal": "icon-scale",
    "Cuidados críticos y heridas complejas": "icon-bandage",
    "Gestión de servicios de salud": "icon-clipboard",
    "Manejo del estrés laboral": "icon-brain",
    "Prevención del burnout": "icon-bolt",
    "Alimentación saludable en el trabajo": "icon-nutrition",
    "Higiene del sueño y descanso": "icon-moon",
    "Actividad física y pausas activas": "icon-workshop",
    "Ergonomía y salud postural": "icon-ruler",
    "RCP y primeros auxilios para no sanitarios": "icon-heartbeat",
    "Seguridad e higiene laboral": "icon-shield-plus",
    "Salud mental en el trabajo": "icon-brain",
    "Prevención de consumos problemáticos": "icon-prevention",
    "Bienestar integral y hábitos saludables": "icon-community",
    "Salud visual y pantallas": "icon-eye",
    "Chequeos preventivos y autocuidado": "icon-checklist",
    "Salud de la mujer y masculinidades": "icon-community",
    "Habilidades blandas y comunicación": "icon-users",
    "Gestión del tiempo y productividad": "icon-target",
};

export default function CapacitacionCourseCatalog({ section }) {
    const groups = useMemo(() => section.groups || [], [section.groups]);
    const [activeGroupTitle, setActiveGroupTitle] = useState(groups[0]?.title || "");

    useEffect(() => {
        if (!groups.length) {
            if (activeGroupTitle) {
                setActiveGroupTitle("");
            }
            return;
        }

        const hasActiveGroup = groups.some((group) => group.title === activeGroupTitle);

        if (!hasActiveGroup) {
            setActiveGroupTitle(groups[0].title);
        }
    }, [activeGroupTitle, groups]);

    const activeGroup = useMemo(
        () => groups.find((group) => group.title === activeGroupTitle) || groups[0],
        [activeGroupTitle, groups]
    );

    return (
        <section className="service-detail-section service-section-course-groups">
            <div className="service-detail-inner">
                <ServiceSectionHead section={section} />

                <div className="capacitacion-group-tabs" role="tablist" aria-label={section.title}>
                    {groups.map((group) => (
                        <button
                            key={group.title}
                            className={`capacitacion-group-tab ${group.title === activeGroup?.title ? "is-active" : ""}`}
                            type="button"
                            role="tab"
                            aria-selected={group.title === activeGroup?.title}
                            onClick={() => setActiveGroupTitle(group.title)}
                        >
                            <span className="capacitacion-group-tab-icon">
                                <ServiceGlyph type={groupIcons[group.title] || "icon-article"} />
                            </span>
                            <span>{group.title}</span>
                        </button>
                    ))}
                </div>

                <div className="capacitacion-group-grid">
                    {activeGroup?.items.map((item) => {
                        const card = mapServiceItem(item);

                        return (
                            <article className="capacitacion-group-card" key={card.title}>
                                <span className="capacitacion-group-card-icon">
                                    <ServiceGlyph type={cardIcons[card.title] || "icon-article"} />
                                </span>
                                <div className="capacitacion-group-card-copy">
                                    <h3>{card.title}</h3>
                                    <p>{card.text}</p>
                                </div>
                            </article>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
